import React, { Fragment, useState, useEffect } from 'react'
import SingleSelect from "../../common/Forms/SingleSelect";
import { fetchSchoolsForExport } from '../../../utils/exportSchoolFilter';

const SchoolSelect = () => {
  const [schools, setSchools] = useState([])
  const [selectedSchool, setSelectedSchool] = useState(null)

  // Shared with ExportSchoolFilter, which is mounted on the same page --
  // schools_for_export walks every exportable order package, so the memo turns
  // two identical heavy requests back into one.
  useEffect(() => {
    let active = true;

    fetchSchoolsForExport()
      .then((data) => { if (active) setSchools(data); })
      .catch(() => { if (active) setSchools([]); });

    return () => { active = false; };
  }, [])

  return (
    <Fragment>
      <input name="export[school_id]"
             value={selectedSchool && selectedSchool.value}
             hidden />
      <SingleSelect
        handleChange={(data) => setSelectedSchool(data) }
        options={schools}
        selectedValue={selectedSchool}
        showCheckbox={true}
        placeholderText='Select School (do not select to download all)'
      />
    </Fragment>
  )
}

export default SchoolSelect
